<i18n>
{
  "en": {
    "close": "Close"
  },
  "fr": {
    "close": "Fermer"
  }
}
</i18n>
<template>
    <v-snackbar
        :top="true"
        :right="true"
        v-model="internalSnackBar.show">
        {{ internalSnackBar.text }}
        <v-btn text class="primary--text" @click="close()"> {{ $t('close') }}
        </v-btn>
    </v-snackbar>
</template>
<script>
export default {
  name: 'appSnackbar',
  data () {
    return {
      internalSnackBar: {
        show: false,
        text: ''
      }
    }
  },
  methods: {
    show (text) {
      this.internalSnackBar.show = true
      this.internalSnackBar.text = text
    },
    close () {
      this.internalSnackBar.show = false
    }
  },
  computed: {
    snackBar () {
      return this.$store.getters.getSnackBar
    }
  }
}
</script>
